import { createReducer, on } from '@ngrx/store';
import * as GroupCatalogsActions from './group-catalogs.actions';
import { GroupCatalogsState } from './group-catalogs.models';

export const initialState: GroupCatalogsState = {
  groups: null,
  loading: false,
  error: null,
};

export const groupCatalogsReducer = createReducer(
  initialState,
  on(GroupCatalogsActions.loadGroupsCatalog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(GroupCatalogsActions.loadGroupsCatalogSuccess, (state, { groups }) => ({
    ...state,
    groups,
    loading: false,
    error: null,
  })),
  on(GroupCatalogsActions.loadGroupsCatalogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(GroupCatalogsActions.resetGroupsCatalog, () => initialState),
);
